import { TermsVersionSummary } from "./types";

// The scheduled amendment that has not taken effect yet, or null when the terms
// in force are the latest ones. The save paths reject a second pending version,
// so at most one exists; the earliest effective date wins if that ever changes,
// since that is the one that replaces the live terms first.
export const findPendingVersion = (
  versions: TermsVersionSummary[] | undefined
): TermsVersionSummary | null => {
  const pending = (versions ?? []).filter(
    (version) => version.isPending && !!version.effectiveDate
  );
  if (pending.length === 0) return null;
  return pending.reduce((earliest, version) =>
    // Both dates are non-null by the filter above.
    version.effectiveDate! < earliest.effectiveDate! ? version : earliest
  );
};
